import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "popupRating" }
const _hoisted_2 = { class: "popupRating_content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "popupRating_icon" }, null, -1)
const _hoisted_4 = { class: "popupRating_text" }
const _hoisted_5 = { class: "popupRating_text" }
const _hoisted_6 = { class: "popupRating_actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_textarea = _resolveComponent("as-textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.rate === 5)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('ratingPopup.rate5')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('ratingPopup.rateOther')), 1),
            _createVNode(_component_as_textarea, {
              class: "popupRating_textarea -grey",
              placeholder: _ctx.$t('ratingPopup.textareaPlaceholder'),
              label: _ctx.$t('textAppeal'),
              name: "message",
              modelValue: _ctx.comment,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
              modelModifiers: { trim: true },
              error: _ctx.smallRateError,
              autofocus: "",
              "auto-resizable": ""
            }, null, 8, ["placeholder", "label", "modelValue", "error"])
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.rate === 5)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "popupRating_button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRatingHandler(true)))
          }, _toDisplayString(_ctx.$t('Close')), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              class: "popupRating_button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRatingHandler()))
            }, _toDisplayString(_ctx.$t('send')), 1),
            _createElementVNode("button", {
              class: "popupRating_button -link",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
            }, _toDisplayString(_ctx.$t('Cancel')), 1)
          ], 64))
    ])
  ]))
}